import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Dashboard from '../pages/Admin/Dashboard';
import AdminUserManagement from '../pages/Admin/UserManagement';
import History from '../pages/Admin/history';
import Logins from '../pages/Admin/Logins';
import Assingment from '../pages/Admin/Assignment';
import Views from '../pages/Admin/views';
import UserDetail from '../pages/Admin/UserDetail';
import Supervisor from '../pages/Admin/supervisor';
import Uploads from '../pages/Admin/upload';
import BulkUpload from '../pages/Admin/BulkUpload';
import { Upload } from 'lucide-react';
import ManageAssignments from '../pages/Admin/ManageAssignments';
import CircleTargets from '../pages/Admin/CircleTargets';

const AdminRoutes = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/Users" element={<AdminUserManagement />} />
    <Route path="/assign" element={<Assingment />} />
    <Route path="/time" element={<Supervisor/>}/>
    <Route path="/LOgins" element={<Logins/>}/>
    <Route path="/history" element={<History/>}/> 
    <Route path="/Views" element={<Views/>}/> 
    <Route path="/Users/:id" element={<UserDetail/>}/> 
    <Route path="*" element={<div>404 Not Found</div>} />
    <Route path="/upload" element={<Uploads/>} />
    <Route path="/bulk-upload" element={<BulkUpload/>} />
    <Route path="/manage-assignments" element={<ManageAssignments />} />
    <Route path="/circle-targets" element={<CircleTargets />} />
    
  </Routes>
);

export default AdminRoutes;
